import { logAndNotifyError, logDebugSilently, notifyWarning } from "../../modules/logger";
import { useNavigate, useParams } from "react-router-dom";
import { post } from "../../modules/server";
import Notify from "devextreme/ui/notify";

import { IRoundHeaderViewModel, RoundStatus, RoundStep, StepTypes, useRound } from "../../modules/roundHandler";
import ModuleFamilyRoundStep from "./ModuleFamilyRoundStep";
import { Card } from "react-bootstrap";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { Colors } from "../../modules/Colors";
import RoundStepReport from "./Report/RoundStepReport";
import StickyBreadCrumb from "../Global/StickyBreadCrumb";
import { useGlobalData } from "../GlobalDataProvider";

const RoundPageStep = () => {
  const [theStep, setTheStep] = useState(undefined as undefined | RoundStep);
  const globalData = useGlobalData();

  if (theStep?.stepType || !theStep?.data?.modules?.length) {
    const dbg = 4;
  }

  logDebugSilently("Render RoundPageStep:" + new Date());

  // const { buildingIndex , stepIndex }  = useParams();
  //New construction that let us read the number value from the params
  const params = useParams();
  let roundId: string | number | undefined = params.roundId;
  let stepIndex: string | number | undefined = params.stepIndex;

  const roundHandler = useRound();
  const navigate = useNavigate();

  if (roundId && stepIndex) {
    roundId = parseInt(roundId as string);
    stepIndex = parseInt(stepIndex);

    const onPrevious = () => {
      if ((stepIndex as number) > 0) navigate("/round/" + roundId + "/" + ((stepIndex as number) - 1).toString());
      else {
        const building = roundHandler.getFinishedRound()?.buildingId as number;

        navigate("/round/building/" + building);
      }
    };

    const onNext = async () => {
      const theRound = roundHandler.getFinishedRound();

      if (theRound) {
        if (theRound.status === RoundStatus.Draft) {
          try {
            const res = await post("SaveRound", theRound);
            if (res?.succeeded) {
              roundHandler.updateLastRoundLocally(res.round);
              Notify("Ändringarna har sparats(draft)", "success");
            } else {
              //Notify("Ändringarna har inte kunnat sparas", "warning");
            }
          } catch (ex) {
            if (globalData.isOnline) {
              notifyWarning("Ändringarna kunde inte sparas - Ronderingen kan fortsättas men behöver sparas vid något senare tillfälle !", 8000);
            }
          }
        } //else theRound is finished => Readonly
      }

      navigate("../" + roundId + "/" + ((stepIndex as number) + 1).toString());
    };

    const activeRound = roundHandler.getActiveRound();

    roundHandler.getRoundStep(roundId, stepIndex).then((retStep) => {
      if (retStep !== theStep) {
        setTheStep(retStep);
      }
    });

    switch (theStep?.stepType) {
      case StepTypes.EnterModulesData:
        if (!activeRound) return <></>; //Shortcut rendering. We will get back here on a rerender with the activeRound set. (This can happen after a page reload / F5)

        return (
          <>
            <StickyBreadCrumb items={roundHandler.getBreadCrumbItems(params)} />
            {activeRound.steps.map((s, i) => {
              switch (s.stepType) {
                case StepTypes.EnterModulesData:
                  return (
                    <Card key={i} className="mt-1">
                      {s.data?.allModulesReady() ? (
                        //If the step is finished, we enable the next step.
                        <Card.Header role="button" onClick={() => navigate("/round/" + roundId + "/" + i)} style={{ backgroundColor: Colors.GrayLight }}>
                          <h5>
                            <FontAwesomeIcon icon={faCircleCheck} className="me-3" color={Colors.GreenDark} />
                            {s.data?.title}
                          </h5>
                        </Card.Header>
                      ) : i > 0 && activeRound.steps[i - 1].stepType === StepTypes.EnterModulesData && activeRound.steps[i - 1].data?.allModulesReady() ? (
                        //If the previous step is finished, we enable the current step.
                        <Card.Header role="button" onClick={() => navigate("/round/" + roundId + "/" + i)} style={{ backgroundColor: Colors.GrayLight }}>
                          <h5>
                            {/* <div style={{ display: "inline-block", width: "3rem" }}></div> */}
                            {s.data?.title}
                          </h5>
                        </Card.Header>
                      ) : (
                        //If the previous step is not finished, we disable the current step.
                        <Card.Header className="cursor-not-allowed" style={{ backgroundColor: Colors.GrayLight }}>
                          <h5>{s.data?.title}</h5>
                        </Card.Header>
                      )}

                      {stepIndex === i ? (
                        //Renders the active step
                        <ModuleFamilyRoundStep header={s?.data as IRoundHeaderViewModel} onPrevious={onPrevious} onNext={onNext} />
                      ) : (
                        // <Card.Body>
                        // </Card.Body>
                        <></>
                      )}
                    </Card>
                  );
                case StepTypes.Finish:
                  //Renders the last step that brings the user to the report upon clicking it.
                  return (
                    <Card key={i} className="mt-1">
                      {i > 0 && activeRound.steps[i - 1].stepType === StepTypes.EnterModulesData && activeRound.steps[i - 1].data?.allModulesReady() ? (
                        <Card.Header role="button" onClick={() => navigate("/round/" + roundId + "/" + i)} style={{ backgroundColor: Colors.GrayLight }}>
                          <h5>
                            <FontAwesomeIcon icon={faCircleCheck} className="me-3" color={Colors.GreenDark} />
                            Rapport
                          </h5>
                        </Card.Header>
                      ) : (
                        //If the previous step is not finished, we disable the report step.
                        <Card.Header className="cursor-not-allowed" style={{ backgroundColor: Colors.GrayLight }}>
                          <h5>Rapport</h5>
                        </Card.Header>
                      )}

                      {stepIndex === i ? <Card.Body>Rapporten</Card.Body> : <></>}
                    </Card>
                  );
                default:
                  return <>Should never occur</>;
              }
            })}
          </>
        );

      case StepTypes.Finish:
        return <RoundStepReport />;

      default:
        return <></>;
    }
  } else return <></>;
};

export default RoundPageStep;
